export default __webpack_public_path__ + "static/media/deflatonftmSLP.81b6a774.png";